import { ref } from 'vue';

/**
 * @param {boolean} initialIsExcl
 * @param {{ btwSetInclUrl?: string, btwSetExclUrl?: string }} boot
 */
export function useBtwToggle(initialIsExcl = true, boot = {}) {
  const isPrivate = ref(!initialIsExcl);

  async function setMode(privateMode) {
    if (typeof window.vsbBtwSwitch === 'function') {
      window.vsbBtwSwitch(privateMode);
      return true;
    }

    const type = privateMode
      ? 'privé (inclusief BTW)'
      : 'zakelijke (exclusief BTW)';
    if (!window.confirm(`Weet je zeker dat je wilt overschakelen naar ${type} prijzen?`)) {
      return false;
    }
    const url = privateMode
      ? boot.btwSetInclUrl || '/index.php?route=common/header/setincl'
      : boot.btwSetExclUrl || '/index.php?route=common/header/setexcl';

    try {
      const response = await fetch(url, { credentials: 'same-origin', method: 'GET' });
      if (!response.ok) {
        window.alert('Kon de prijsweergave niet wijzigen.');
        return false;
      }
      window.location.reload();
      return true;
    } catch {
      window.alert('Kon de prijsweergave niet wijzigen.');
      return false;
    }
  }

  async function onToggle() {
    await setMode(!isPrivate.value);
  }

  return { isPrivate, onToggle };
}
